// 监控
import monitor from '@/views/qianchuan/monitor'
import warning from '@/views/qianchuan/monitor/warning'
// import log from '@/views/qianchuan/monitor/log'
import log from '@/views/monitor/operationLog'
export default {
  path: '/qianchuan/monitor',
  name: 'monitor',
  component: monitor,
  meta: {
    keepAlive: true,
    title: '监控',
    code: 'page:monitor',
    activeName: '/monitor',
    permission: 'monitor',
    name: 'qcwarning'
  },
  children: [
    {
      path: 'warning',
      name: 'qcwarning',
      component: warning,
      meta: {
        keepAlive: true,
        title: '监控预警',
        iconName: 'icon-menuJk',
        permission: 'monitoring'
      },
      children: [
        {
          path: 'intelligentManage',
          name: 'qcintelligentManage',
          component: resolve => require(['@/views/qianchuan/monitor/intelligentManage'], resolve),
          meta: {
            keepAlive: true,
            title: '新建智能托管'
          }
        }
      ]
    },
    {
      path: 'log',
      name: 'qclog',
      component: log,
      meta: {
        keepAlive: true,
        title: '操作日志',
        iconName: 'icon-menuCz',
        permission: 'operation'
      }
    },
    {
      path: 'taskCenter',
      name: 'qctaskCenter',
      component: resolve => require(['@/views/monitor/taskCenter'], resolve),
      meta: {
        keepAlive: true,
        title: '任务中心',
        iconName: 'icon-renwuzhongxin',
        permission: 'adTask'
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/qianchuan/monitor.js